import { render, staticRenderFns } from "./other-business.vue?vue&type=template&id=3c609f36&scoped=true"
var script = {}
import style0 from "./other-business.vue?vue&type=style&index=0&id=3c609f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c609f36",
  null
  
)

export default component.exports